import type { FC } from 'react';
import { Box } from '@chakra-ui/react';
import { TextVariant } from '../text-variant/TextVariant';
import { Chip } from './Chip';

export interface ChipItem {
    label: string;
    value: string;
    id: string;
}
export interface ChipListProps {
    chipListItems: ChipItem[];
    activeId?: string;
    label?: string;
    size?: 'small' | 'default';
    onClick: (activeProductId: string) => void;
    variationName?: string;
}

export const ChipList: FC<ChipListProps> = ({
    activeId,
    size = 'default',
    onClick,
    label,
    chipListItems,
    variationName,
}) => {
    const handleClick = (id?: string): void => {
        if (id) {
            onClick(id);
        }
    };

    return (
        <Box display="flex" flexDirection="column" data-testid="chip-list-container" gap={2}>
            {label && <TextVariant label={label} value={variationName} />}
            <Box display="flex" flexWrap="wrap" alignItems="center" gap={2}>
                {chipListItems.map((chip, index) => (
                    <Chip
                        testId={`product-${activeId}-variant-${chip.id}-chip-${index}-button`}
                        key={chip.id}
                        isActive={activeId === chip.id}
                        id={chip.id}
                        onClick={handleClick}
                        value={chip.value}
                        size={size}
                    >
                        {chip.label}
                    </Chip>
                ))}
            </Box>
        </Box>
    );
};

ChipList.defaultProps = {
    activeId: undefined,
    label: undefined,
    size: 'default',
    variationName: undefined,
};
